export const TRIP_TYPES = {
  ROUND_TRIP: 'ROUND_TRIP',
  ONE_WAY: 'ONE_WAY',
  MULTI_STOP: 'MULTI_STOP',
};

export const CLASS_TYPES = {
  ECONOMY: 'ECONOMY',
  PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
  BUSINESS: 'BUSINESS',
  FIRST: 'FIRST',
};

export const CLASS_TYPES_TRACKING = {
  [CLASS_TYPES.ECONOMY]: 'economy',
  [CLASS_TYPES.PREMIUM_ECONOMY]: 'premium_economy',
  [CLASS_TYPES.BUSINESS]: 'business_class',
  [CLASS_TYPES.FIRST]: 'first_class',
};

export const DIRECTIONS = {
  DEPARTURE: 'DEPARTURE',
  DESTINATION: 'DESTINATION',
};
